import { trackEvent } from "../track";
let reviewTitle = "";
let submitted = false;

const setBvSubmitReviewEvent = (summaryModal) => {
  setTimeout(() => {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function() {
        const successModal =  summaryModal.shadowRoot.querySelector("#bv-ips-successpop-popup");
        const itemName = summaryModal.shadowRoot?.querySelector("h1#bv-ips-loading-text_bv-ips-title")?.textContent;
        let reviewTitleInput = summaryModal.shadowRoot?.querySelector("#bv-ips-step-0")?.querySelector("input");
        if (reviewTitleInput && reviewTitleInput.value !== undefined) {
          reviewTitle = reviewTitleInput.value.trim();
        }
        if (successModal && !submitted) {
          trackEvent({
            event: "submit_review",
            event_type: "submit",
            item_name: itemName,
            review_title: reviewTitle || "none"
          });
          submitted = true;
          observer.disconnect();
        }
      });
    })
    observer.observe(summaryModal.shadowRoot, { childList: true, subtree: true });
  }, 2e3);
}
export const setBvModalObserver = () => {
  const body = document.querySelector('body');
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function() {
      const summaryModal = document.querySelector("[data-bv-inpagesource='rating_summary']");
      const swatSummaryModal = document.querySelector("[data-bv-inpagesource='swat_reviews']");
      if (summaryModal || swatSummaryModal) {
        if (summaryModal) setBvSubmitReviewEvent(summaryModal);
        if (swatSummaryModal) setBvSubmitReviewEvent(swatSummaryModal);
        observer.disconnect();
      }
    });
  });
  observer.observe(body, { childList: true, subtree: true });
}